import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="relative overflow-hidden py-16 md:py-20">
      <img
        src="https://readdy.ai/api/search-image?query=wide%20anime%20manga%20banner%20of%20open%20comic%20book%20pages%20with%20floating%20colorful%20panels%20and%20sparkles%2C%20warm%20orange%20vermillion%20and%20gold%20on%20dark%20background%2C%20inviting%20stylized%20illustration%2C%20high%20detail&width=1800&height=800&seq=manga-cta-2026&orientation=landscape"
        alt="加入4399漫画网开启追漫之旅"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/70 to-background-950/85"></div>
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center md:px-6">
        <h2 className="font-display text-2xl leading-snug text-background-50 md:text-4xl">
          今天想看点什么漫画？<br className="hidden md:block" /> 万千作品等你来发现
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm text-background-100/85 md:text-base">
          从热血战斗到甜蜜恋爱，从悬疑烧脑到爆笑日常，总有一部漫画戳中你的心。立即开启高效追漫之旅。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link to="/comics" className="rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 hover:bg-primary-400 whitespace-nowrap">
            开始浏览漫画
          </Link>
          <Link to="/comics?sort=completed" className="rounded-full border border-background-50/30 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 hover:bg-background-50/20 whitespace-nowrap">
            看看完结作品
          </Link>
        </div>
      </div>
    </section>
  );
}